import React from "react";

interface DeleteModalProps {
  title: string;
  message?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isOpen: boolean;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  title,
  message = "",
  onConfirm,
  onCancel,
  isOpen,
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    try {
      onConfirm(); // Execute the Promise function
      onCancel(); // Close the modal after successful execution
    } catch (error) {
      console.error("Error during delete operation:", error);
    }
  };

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onCancel();
    }
  };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-[400px]">
        <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
        {message && <p className="mt-2 text-sm text-gray-600">{message}</p>}
        <div className="mt-4 flex justify-end gap-2">
          <button
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            onClick={handleConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
